module.exports = __webpack_public_path__ + "static/media/logo.0dd2a339.png";